const BTN = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  ICON: 'icon',
  CUSTOMIZED: 'customized',
  DISABLE: 'disabled',
};
export default BTN;
